import BigBenBridgeColour from '../assets/backgrounds/Houses_Of_Parliament_882x496_Colour.png';
import ParliamentFoyer from '../assets/backgrounds/Parliament_Foyer_882x496_Colour.png';
import HouseOfCommons from '../assets/backgrounds/House_Of_Commons_882x496_Colour.png';
import PressRoom from '../assets/backgrounds/Press_Room_882x496_Colour.png';

const backgrounds = {
    'Title Screen': BigBenBridgeColour,
    'Game Settings Screen': BigBenBridgeColour,
    'Welcome Letter Screen': BigBenBridgeColour,
    'Start of Day Screen': BigBenBridgeColour,
    'Settings Screen': BigBenBridgeColour,

    'Main Game Screen': BigBenBridgeColour,
    'Quickplay Screen': BigBenBridgeColour,

    'Messages Game Screen': ParliamentFoyer,
    'Meetings Game Screen': ParliamentFoyer,
    'Inquiry Game Screen': ParliamentFoyer,
    'Vote Game Screen': HouseOfCommons,
    'Questions Game Screen': HouseOfCommons,
    'Debate Game Screen': HouseOfCommons,
    'Press Game Screen': PressRoom,

    'Time Passing Screen': BigBenBridgeColour,
    'End of Day Screen': ParliamentFoyer,
};

export const getBackgroundFromPage = page => {
    return backgrounds[page];
};

export const allBackgrounds = [
    BigBenBridgeColour,
    ParliamentFoyer,
    HouseOfCommons,
    PressRoom,
];
